import React, { useEffect } from 'react'
import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { routerPath } from '../../navigation/path';
import { IMAGES } from '../../../assets/images';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from '../../../store/slices/userSlice';
import { Modal } from 'react-bootstrap';

const Header = () => {
    const location = useLocation()
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const userName = useSelector((state) => state.users.user.name)
    const TotalSavings = useSelector((state) => state.categories.savings)
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
    })

    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    const sendToMenu = (menu) => {
        menu == 'home' && navigate(routerPath.home)
        menu == 'about' && navigate(routerPath.about)
        menu == 'offer' && navigate(routerPath.offer)
        menu == 'previlages' && navigate(routerPath.previlages)
        menu == 'your-offers' && navigate(routerPath.yourOffers)
        menu == 'orderHistory' && navigate(routerPath.OrderHistory)
        menu == 'profile' && navigate(routerPath.profile)
        menu == 'my-account' && navigate(routerPath.myAccount)
        menu == 'savings' && navigate(routerPath.savings)

    }

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const logoutUser = () => {
        setShowModal(true)
        // dispatch(logout())
    }

    const isActive = (path) => {
        return location.pathname === path;
    }

    return (
        <>
            <MobileMenu isOpen={isSidebarOpen} onClose={toggleSidebar} />
            <header className="bg-[#FFFFFF]">
                <div className="flex items-center py-2 px-2">
                    <div className="text-white text-xl font-bold flex-1 cursor-pointer" onClick={() => sendToMenu('home')}>
                        <img src={IMAGES.logo} alt="" className='w-50' />
                    </div>
                    <div className="block lg:hidden">
                        <button
                            onClick={toggleSidebar}
                            className="text-white focus:outline-none focus:text-white"
                        >
                            <svg
                                className="h-6 w-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16m-7 6h7"
                                ></path>
                            </svg>
                        </button>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex md:flex-[2] flex-wrap justify-evenly">
                        <p className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.home) ? 'text-[#0673EA] font-bold' : 'text-[#515B6F]'}`} onClick={() => sendToMenu('home')}>Home</p>
                        <p className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.about) ? 'text-[#0673EA] font-bold' : 'text-[#515B6F]'}`} onClick={() => sendToMenu('about')}>About Us</p>
                        <p className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.offer) ? 'text-[#0673EA] font-bold' : 'text-[#515B6F]'}`} onClick={() => sendToMenu('offer')}>Offers</p>
                        <p className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.previlages) ? 'text-[#0673EA] font-bold' : 'text-[#515B6F]'}`} onClick={() => sendToMenu('previlages')}>Privileges</p>
                        <p className={`mb-0 text-[16px] font-semibold text-center cursor-pointer ${isActive(routerPath.yourOffers) ? 'text-[#0673EA] font-bold' : 'text-[#515B6F]'}`} onClick={() => sendToMenu('your-offers')}>Your Offers</p>
                    </div>

                    {/* Mobile Menu */}
                    {isMenuOpen && (
                        <div className="lg:hidden absolute top-0 left-0 w-full h-screen bg-[#0673EA]">
                            <div className="flex flex-col  pt-8 space-y-4">
                                <div className='text-end pr-5'>
                                    <button
                                        onClick={toggleMenu}
                                        className="text-white focus:outline-none focus:text-white"
                                    >
                                        <svg
                                            className="h-6 w-6"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M4 6h16M4 12h16m-7 6h7"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>

                                <ul >
                                    <li className='text-white justify-between items-left cursor-pointer pt-3 flex' onClick={() => sendToMenu('home')}>Home</li>
                                    <li className='text-white justify-between items-left cursor-pointer flex pt-3' onClick={() => sendToMenu('about')}>About Us</li>
                                    <li className='text-white justify-between items-left cursor-pointer flex pt-3' onClick={() => sendToMenu('offer')}>Offers</li>
                                    <li className='text-white justify-between items-left cursor-pointer flex pt-3' onClick={() => sendToMenu('previlages')}>Privileges</li>
                                    <li className='text-white justify-between items-left cursor-pointer flex pt-3' onClick={() => sendToMenu('your-offers')}>Privileges</li>
                                    <li className='text-white justify-between items-center w-32 font-bold cursor-pointer' onClick={logoutUser}>Logout</li>

                                </ul>
                            </div>
                        </div>
                    )}

                    {/*User Details */}

                    <div className="hiddenb md:flex  md:flex-[2] md:justify-end">
                        <div className='border-r-[1px] border-[#D6DDEB] px-[24px]'>
                            <button type='btn' className='bg-[#21438F] py-[12px] px-[24px] rounded-[4px] text-[16px] font-bold text-white' onClick={() => sendToMenu('savings')}>Your Savings : {TotalSavings}</button>
                        </div>
                        <div className='border-r-[1px] border-[#D6DDEB] py-[12px] px-[24px]'>
                            <p className='m-0 text-[#21438F] text-[16px] font-bold cursor-pointer' onClick={() => sendToMenu('my-account')} >{userName}</p>
                        </div>
                        <div className='cursor-pointer py-[12px] px-[24px]'>
                            <p className='m-0 text-[#21438F] text-[16px] font-bold' onClick={logoutUser}>Logout</p>
                        </div>
                    </div>

                </div>

                <Modal show={showModal} onHide={() => setShowModal(false)} centered size="md">

                    <Modal.Body>
                        <div >
                            <h4 className='pt-2'>
                                Are you sure you want to Logout ?
                            </h4>
                            <div className='flex mt-4'>
                                <button className='w-[48%] mx-[1%] bg-red-700 text-white h-[40px] rounded' onClick={() => setShowModal(false)}>
                                    No
                                </button>
                                <button className='w-[48%] mx-[1%] bg-green-700 text-white h-[40px] rounded' onClick={() => {
                                    dispatch(logout());
                                    localStorage.clear()
                                    localStorage.setItem('currentPath', '/login');
                                    navigate(routerPath.Login)
                                }
                                }>
                                    Yes
                                </button>
                            </div>

                        </div>
                    </Modal.Body >
                </Modal >
            </header>
        </>


    )
}

export default Header


const MobileMenu = ({ isOpen, onClose }) => {
    const navigate = useNavigate()
    const sendToMenu = (menu) => {
        console.log(menu)
        menu == 'home' && navigate(routerPath.home)
        menu == 'about' && navigate(routerPath.about)
        menu == 'offer' && navigate(routerPath.offer)
        menu == 'orderHistory' && navigate(routerPath.OrderHistory)
        menu == 'profile' && navigate(routerPath.profile)
        menu == 'previlages' && navigate(routerPath.previlages)
        menu == 'your-offers' && navigate(routerPath.yourOffers)
    }
    const [isUserLogin, setUserLogin] = useState(false)
    useEffect(() => {
        const userLogin = JSON.parse(localStorage.getItem('is_user_login')) || false;
        setUserLogin(userLogin)
    })
    return (

        <div className={`fixed w-[85vw] inset-y-0 left-0 bg-[#0673EA] z-50 transform transition duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
            <div className="flex items-center justify-between p-4 cursor-pointer">
                {/* <h1 className="text-black text-lg font-semibold">Product categories</h1> */}
                <img src={IMAGES.logo} alt="" className='w-[60px]' onClick={() => sendToMenu('home')} />
                <button onClick={onClose} className="text-white focus:outline-none">
                    <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M12.3 10l5.4-5.4c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-5.4 5.4-5.4-5.4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5.4 5.4-5.4 5.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l5.4-5.4 5.4 5.4c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-5.4-5.4z"></path>
                    </svg>
                </button>
            </div>
            <div className="overflow-y-auto h-full">
                {/* Sidebar content */}
                <div className='px-4 mt-5'>
                    {/* <p className="font-bold text-md">
                        Offers
                    </p> */}
                    <div className="ml-4 pb-5">
                        <p className='text-white justify-between items-center w-32 font-bold cursor-pointer' onClick={() => sendToMenu('home')}>Home </p>
                        <p className='text-white justify-between items-center w-32 font-bold cursor-pointer' onClick={() => sendToMenu('about')}>About Us</p>
                        <p className='text-white justify-between items-center w-32 font-bold cursor-pointer' onClick={() => sendToMenu('offer')}>Offers</p>
                        <p className='text-white justify-between items-center w-32 font-bold cursor-pointer' onClick={() => sendToMenu('previlages')}>Privileges</p>
                        <p className='text-white justify-between items-center w-32 font-bold cursor-pointer' onClick={() => sendToMenu('your-offers')}>Your Offers</p>
                        {
                            isUserLogin &&
                            <p className='text-white justify-between items-center w-32 font-bold cursor-pointer' onClick={() => sendToMenu('orderHistory')}>Order History</p>
                        }
                        {
                            isUserLogin &&
                            <p className='text-white justify-between items-center w-32 font-bold cursor-pointer' onClick={() => sendToMenu('profile')}>Profile</p>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};